// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__23wCM","rootCenter":"LoadMoreObserver_rootCenter__1cGlP","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__3Ow85"};